// extracted by mini-css-extract-plugin
module.exports = {"grid":"special-offers-styles-module--grid--4oWVR","button":"special-offers-styles-module--button--2iQqb"};